export const getFileType = (url: string, type?: string | null): string => {
  const extension = type
    ? type.split("/").pop()?.toLowerCase() || ""
    : url.split(".").pop()?.toLowerCase() || "";
  const imageExtensions = ["jpg", "jpeg", "png", "gif", "svg", "webp"];
  const documentExtensions = ["pdf", "doc", "docx", "txt", "odt"];
  const spreadsheetExtensions = ["xlsx", "csv"];
  const presentationExtensions = ["pptx"];

  if (imageExtensions.includes(extension)) return "image";
  if (documentExtensions.includes(extension)) return "document";
  if (spreadsheetExtensions.includes(extension)) return "spreadsheet";
  if (presentationExtensions.includes(extension)) return "presentation";

  return "unknown";
};
